import { getBridge } from '@/platform';

/**
 * Единая точка системной кнопки «Назад».
 *
 * Раньше каждый экран подписывался на неё сам, и при наложении экрана и листа
 * обработчики затирали друг друга: снятие одного скрывало кнопку, хотя второй
 * ещё был нужен. Теперь обработчики складываются стопкой, а нажатие получает
 * верхний — открытый лист закрывается раньше, чем происходит переход назад.
 *
 * Подписка на мост одна на всё приложение: клиенты мессенджера по-разному
 * относятся к повторным подписчикам, и держать их по числу экранов рискованно.
 */
type BackHandler = () => void;

const handlers: BackHandler[] = [];
let unsubscribe: (() => void) | null = null;

function sync(): void {
  const bridge = getBridge();
  const active = handlers.length > 0;

  bridge.setBackButtonVisible(active);

  if (active && !unsubscribe) {
    unsubscribe = bridge.onBackButton(() => {
      // Верхний обработчик — самый свежий: лист поверх экрана закрывается первым
      handlers[handlers.length - 1]?.();
    });
    return;
  }

  if (!active && unsubscribe) {
    unsubscribe();
    unsubscribe = null;
  }
}

export function pushBackHandler(handler: BackHandler): () => void {
  handlers.push(handler);
  sync();

  return () => {
    const index = handlers.lastIndexOf(handler);
    if (index !== -1) handlers.splice(index, 1);
    sync();
  };
}

/** Только для тестов: снять все обработчики между сценариями. */
export function resetBackHandlers(): void {
  handlers.length = 0;
  if (unsubscribe) {
    unsubscribe();
    unsubscribe = null;
  }
}
